// extracted by mini-css-extract-plugin
export default {"rankTable":"RankingPage_rankTable__fvKDQ"};